import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';

const baseUrl = window.location.origin;
const AAD_SCOPES = ['https://dsilo.ai/auth-api/Task.Read', 'https://dsilo.ai/auth-api/Task.Write'];

export const getMsalInstance = msalADData => {
    const { authorityDomain, clientId, policyName, tenantName } = msalADData;
    const authority = `https://${authorityDomain}/${tenantName}/${policyName}`;
    const msalConfig = {
        auth: {
            clientId,
            authority, // `https://login.microsoftonline.com/${tenantId}`,
            knownAuthorities: [authorityDomain],
            redirectUri: `${baseUrl}/mfaaad`,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: 'localStorage', // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
    };
    const msalInstance = new PublicClientApplication(msalConfig);
    return msalInstance;
};

export const loginRedirect = msalADData => {
    const { loginHint } = msalADData;
    if (loginHint) {
        localStorage.setItem('mfaLoginHint', loginHint);
    }
    sessionStorage.removeItem('msal.interaction.status');
    const loginRequest = {
        // scopes: [`${clientId}/.default`],
        scopes: AAD_SCOPES,
        loginHint,
        // Force new sign-in so Entra doesn't reuse another environment's session (same tenant, different clientId)
        prompt: 'login'
    };
    const msalInstance = getMsalInstance(msalADData);
    msalInstance.loginRedirect(loginRequest);
};

export const handleRedirect = async (msalADData) => {
    const msalInstance = getMsalInstance(msalADData);
    const result = await msalInstance.handleRedirectPromise();
    return result;
};

const selectAccount = (msalInstance, msalADData) => {
    const activeAccount = msalInstance.getActiveAccount();
    if (activeAccount) {
        return activeAccount;
    }

    const accounts = msalInstance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
        return null;
    }

    const storedHomeAccountId = localStorage.getItem('aad.msal.homeAccountId');
    if (storedHomeAccountId) {
        const storedAccount = accounts.find(account => account.homeAccountId === storedHomeAccountId);
        if (storedAccount) {
            return storedAccount;
        }
    }

    if (msalADData?.loginHint) {
        const hintedAccount = accounts.find(account => account.username === msalADData.loginHint);
        if (hintedAccount) {
            return hintedAccount;
        }
    }

    return accounts[0];
};

export const acquireAadTokenSilent = async (msalADData, options = {}) => {
    const { forceRefresh = false, allowRedirectFallback = true } = options;
    const msalInstance = getMsalInstance(msalADData);
    const account = selectAccount(msalInstance, msalADData);
    const tokenRequest = {
        scopes: AAD_SCOPES,
        forceRefresh,
        loginHint: msalADData?.loginHint,
    };

    if (account) {
        tokenRequest.account = account;
    }

    try {
        const result = await msalInstance.acquireTokenSilent(tokenRequest);
        if (result?.accessToken) {
            if (result.account) {
                msalInstance.setActiveAccount(result.account);
            }
            localStorage.setItem('jwt_access_token', result.accessToken);
            if (result.account?.homeAccountId) {
                localStorage.setItem('aad.msal.homeAccountId', result.account.homeAccountId);
            }
            if (result.expiresOn) {
                localStorage.setItem('aad.msal.expiresOn', result.expiresOn.toISOString());
            }
        }
        return result;
    } catch (error) {
        if (allowRedirectFallback && error instanceof InteractionRequiredAuthError) {
            sessionStorage.removeItem('msal.interaction.status');
            await msalInstance.acquireTokenRedirect(tokenRequest);
            return null;
        }
        throw error;
    }
};

export const logoutRedirect = async (msalADData) => {
    const { authorityDomain, policyName, tenantName } = msalADData;
    const authority = `https://${authorityDomain}/${tenantName}/${policyName}`;
    const msalInstance = getMsalInstance(msalADData);
    const result = await msalInstance.logoutRedirect({
        authority, // `https://login.microsoftonline.com/${tenantId}`, 
        postLogoutRedirectUri: `${baseUrl}/login`
    });
    return result;
};
